import { CSSProperties } from 'react';
import { FelaCSS } from '@bridebook/ui';

interface IProps {
  fullBleed?: boolean;
}

interface IStyles {
  pillBackground: FelaCSS;
  trashIcon: CSSProperties;
}

const styles = ({ fullBleed }: IProps): IStyles => ({
  pillBackground: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  trashIcon: {
    fontSize: fullBleed ? '17px' : '19px',
    marginTop: '2px',
  },
});
export default styles;
